module.exports = __webpack_public_path__ + "static/media/IconAdd.07b9930e.svg";